import { Row, Modal, Button, Radio, Form, TimePicker, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { isValid, isValidArray } from '../../../utils/utilities';
import { getUnqiueOriginCities, getBoardingPointsTemplatesByCities, getBoardingPoints } from './import-boarding-points.module';
import { addMin, get24HoursTime } from './../../../utils/date.utils';
import { createBoardingPointsAction, getPickupLocationsByScheduleId } from './../../../actions/trip-actions';
import { QB_USER } from './../../../utils/constant';

const getFormatedTemplates = (templates) => {
  let formatedData = [], addedTemplate = [];
  if (isValidArray(templates)) {
    templates.forEach(element => {
      if (addedTemplate.indexOf(element) == -1) {
        formatedData.push({
          label: element,
          value: element
        });
        addedTemplate.push(element);
      }
    });
  }
  return formatedData;
}

const getFormateBoardingPoints = (boardingPoints, scheduleId) => {
  let formatedBoardingPoints = [];
  if (isValidArray(boardingPoints) && boardingPoints.length > 0) {
    boardingPoints.forEach(element => {
      formatedBoardingPoints.push({
        timing: get24HoursTime(element.boardingTime),
        address: element.address,
        phone_number: element.phone_number,
        landmark: element.landmark,
        city: element.city,
        trip_close_point: element.trip_close_point,
        route_close_point: element.route_close_point,
        is_temporary: element.is_temporary,
        schedule_id: scheduleId,
        location: element.location,
        latitude: element.latitude,
        longitude: element.longitude,
        updated_by: global.user_name
      });
    });
  }
  return formatedBoardingPoints;
}

export const ImportBoardingPoints = (props) => {

  const {
    selectedTrip,
    routes
  } = props;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [boardingPoints, setBoardingPoints] = useState([]);
  const [startTimeOfBp, setStartTimeOfBp] = useState(null);
  const [templates, setTemplates] = useState([]);

  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    handleCancel();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setBoardingPoints([]);
    setStartTimeOfBp(null);
  };

  useEffect(() => {
    let uniqueOrigins = getUnqiueOriginCities(routes);
    getBoardingPointsTemplatesByCities(uniqueOrigins, (data) => {
      setTemplates([...data]);
    });
  }, [routes]);

  const dispatch = useDispatch();

  const onFinish = (values) => {
    let {
      templateName,
      startTime
    } = values;
    setStartTimeOfBp(startTime);
    dispatch(getBoardingPoints(templateName, selectedTrip.id, (data) => {
      setBoardingPoints(data);
    }));
  }

  const boardingPointColumns = [
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address'
    },
    {
      title: 'Start time',
      dataIndex: 'boardingTime',
      key: 'boardingTime',
      render: (text, rowIndex, viewIndex) => {
        let row = boardingPoints[viewIndex];
        let timing;
        if (!isValid(text)) {
          timing = addMin(startTimeOfBp, row.off_set);
          boardingPoints[viewIndex].boardingTime = timing;
          setBoardingPoints([...boardingPoints]);
        } else {
          timing = text;
        }
        return <TimePicker
          value={timing}
          use12Hours
          format='h:mm A'
          popupClassName={"time-picker-to-not-display-footer"}
          onSelect={(value) => {
            boardingPoints[viewIndex].boardingTime = value;
            setBoardingPoints([...boardingPoints]);
          }}
        />
      }
    }
  ]

  if (isValidArray(selectedTrip) && isValid(selectedTrip.id) && QB_USER === global.name) {
    return (
      <Row type='flex' justify="center" align="middle">
        <Button type="primary" onClick={showModal}>
          Import
        </Button>
        <Modal title="Import Boarding Points" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} footer={null}>
          <Form
            // {...layout}
            className="form"
            form={form}
            name="basic"
            initialValues={{}}
            onFinish={onFinish}
          >
            <Form.Item
              label="Template"
              name="templateName"
              rules={[{
                required: true,
                message: 'Please input your template!'
              }]}
            >
              <Radio.Group
                options={getFormatedTemplates(templates)}
              />
            </Form.Item>
            <Form.Item
              label="Boarding point start time"
              name="startTime"
              rules={[{
                required: true,
                message: 'Please input your boarding point start time!'
              }]}
            >
              <TimePicker
                use12Hours
                format='h:mm A'
                popupClassName={"time-picker-to-not-display-footer"}
                onSelect={(value) => {
                  form.setFieldsValue({
                    startTime: value
                  })
                }}
              />
            </Form.Item>
            <Form.Item>
              <Button htmlType="submit" type="primary">Get</Button>
            </Form.Item>
          </Form>
          {isValidArray(boardingPoints) && boardingPoints.length > 0 ?
            <div>
              <Table
                pagination={false}
                style={{ margin: '10px' }}
                dataSource={boardingPoints}
                columns={boardingPointColumns}
              />
              <Button type="primary"
                onClick={() => {
                  let data = getFormateBoardingPoints(boardingPoints, selectedTrip.id);
                  dispatch(createBoardingPointsAction(data, () => {
                    dispatch(getPickupLocationsByScheduleId(selectedTrip.id));
                    handleCancel()
                  }));
                }}>Import</Button>
            </div>
            : null
          }
        </Modal>
      </Row>
    );
  } else {
    return null;
  }
};